import { SIDEBAR_TOGGLE_VISIBILITY } from '../constants/actionTypes';

export const toggleSidebar = () => ({
	type: SIDEBAR_TOGGLE_VISIBILITY,
});



// WEBPACK FOOTER //
// ./src/actions/sidebar.js